export default {
    buildQueryString: function ( parameters ) {
        let query = '';
        Object.keys( parameters ).forEach( parameter => {
            if( Array.isArray(parameters[parameter] ) ) {
                parameters[parameter].forEach( value => {
                    query += query ? '&' : '';
                    query += parameter +'[]='+value;
                });
            }
            else {
                query += query ? '&' : '';
                query += parameter + '='+parameters[parameter];
            }
        });
        return query;
    }
};